module.exports = __webpack_public_path__ + "img/X_dark.793c4afb.svg";